<template>
  <div>
    <em style="cursor: pointer;position:absolute;right: 160px;line-height: 60px" class="el-icon-search"
       v-on:click="goSearchPage"></em>
  </div>
</template>

<script>
export default {
  name: "HeaderSearch",
  methods: {
    /**
     * 跳转搜索
     */
    goSearchPage() {
      this.$router.push('/search')
    }
  }
}
</script>

